import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { OrangeTextButton } from "../../common/OrangeTextButton";

/**
 * Copyable raw coordinates for an action-log preview, so support can read back
 * a zone or line exactly as it was saved (normalized 0-1 values).
 */
export const HistoryCoordinates = ({ value }: { value: unknown }) => {
  const [copied, setCopied] = React.useState(false);
  const text = JSON.stringify(value);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
    } catch {
      setCopied(false);
    }
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography sx={{ fontFamily: "Mulish", fontWeight: "bold" }}>
          Coordinates
        </Typography>
        <OrangeTextButton
          onClick={handleCopy}
          text={copied ? "Copied" : "Copy"}
          disabled={false}
        />
      </Box>
      <Box
        component="pre"
        data-testid="history-coordinates"
        sx={{
          m: 0,
          p: 1,
          fontSize: "12px",
          whiteSpace: "pre-wrap",
          wordBreak: "break-all",
          backgroundColor: "#F5F5F5",
          borderRadius: 1,
        }}
      >
        {text}
      </Box>
    </Box>
  );
};
